import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MenuItem, MessageService, SelectItem} from 'primeng/api';
import { DeliveryOrderService, AppDataService } from 'app/services';
import {PayoutTransactionStatusEnum} from 'app/models/transaction/payout-transaction-status.enum';
import {StylesStatus} from 'app/models/users/StylesStatus';
import {CebuanaPayoutTransactionService} from 'app/services/cebuana-payout-transaction.service';

enum TransactionDetailsTab {
    PayoutTransaction = 1
}

@Component({
    selector: 'finance-payout-details',
    templateUrl: './finance-payout-details.component.html',
    styleUrls: ['./finance-payout-details.component.scss'],
    providers: [MessageService]
})

export class FinancePayoutDetailsComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    @Input()
    set _payoutTransaction(value: any) {
        if (value != null) {
            this.payoutTransaction = value;
            this.getPayoutTransactionDetail();
        }
    }

    @Input()
    public showTransactionsSidebar: boolean = false;

    @Input()
    public onHide: () => void = () => { };

    @Output()
    updateTransactionsEmit = new EventEmitter<boolean>();

    payoutTransaction: any;
    loading: boolean = false;
    visibleDriverDetail: boolean = false;
    showEditFields: boolean = false;
    transactionDetailsTab = TransactionDetailsTab;
    activeTab: TransactionDetailsTab = TransactionDetailsTab.PayoutTransaction;
    menuItems: MenuItem[] = [
        {
            label: 'Payout Transaction',
            id: `${TransactionDetailsTab.PayoutTransaction}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        }
    ];

    serviceTypes: any =
    [
        {
            label: 'Pending', value: PayoutTransactionStatusEnum.Pending
        },
        {
            label: 'Processing', value: PayoutTransactionStatusEnum.Processing
        },
        {
            label: 'Completed', value: PayoutTransactionStatusEnum.Completed
        },
    ];


    constructor(
        public appData: AppDataService,
        private messageService: MessageService,
        private payoutTransactionService: CebuanaPayoutTransactionService
    ) {
    }

    ngOnInit(): void {
    }

    cancel() {
        this.onHide();
    }

    getStatusName(status: PayoutTransactionStatusEnum): string {
        return this.serviceTypes.find((item: SelectItem) => item.value === status).label;
    }

    getStatusStyles(status: number): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        switch (status) {
            case PayoutTransactionStatusEnum.Completed:
                backgroundColor = '#E7F7EF';
                textColor = '#1CBA70';
                break;
            case PayoutTransactionStatusEnum.Pending:
                backgroundColor = '#FFEFCC';
                textColor = '#FFB100';
                break;
            case PayoutTransactionStatusEnum.Processing:
                backgroundColor = '#FDEBEA';
                textColor = '#EB4236';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    handleTabChange(tab: TransactionDetailsTab) {
        this.activeTab = tab;
    }

    getPayoutTransactionDetail() {
        const dto = {
            Id: this.payoutTransaction.Id
        };

        this.payoutTransactionService.getPayoutTransactionDetail(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.payoutTransaction = data.PayoutTransaction;
            });

    }

    updatePayoutTransaction() {
        const dto = {
            Id: this.payoutTransaction.Id,
            ControlNumber: this.payoutTransaction.ControlNumber,
            BranchCode: this.payoutTransaction.BranchCode,
            Status: this.payoutTransaction.Status,
        };
        this.payoutTransactionService.updatePayoutTransaction(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Payout transaction has been updated' });
                this.getPayoutTransactionDetail();
                this.updateTransactions();
                this.showEditFields = false;
            });

    }

    changedVisibleDriverDetailEmit(value: any) {
        this.visibleDriverDetail = value;
    }

    updateTransactions() {
        this.updateTransactionsEmit.emit(true);
    }

    handleShowDriverInfo() {
        this.visibleDriverDetail= true;
    }
}
